<template>

        <div class="more-icon">
            <button class="icon" ref="moreBtn" @click="setFocus()">
                <SvgIcon icon="more" />
            </button>
            <ul>
                <slot></slot>
            </ul>
        </div>


</template>

<script>
    import SvgIcon from './Svg.vue';
    export default {
        data: () => ({
            
        }),
        methods:{
            setFocus: function()
            {
              this.$refs.moreBtn.focus();
            }
        },
        components:{
            SvgIcon
        }
    }
</script>

<style lang="scss">

</style>